import React from "react";
import { CircularProgress, Stack } from "@mui/material";

const Loading = (props) => {
    const { children, loading, customLoadingElement } = props;

    let component

    if (loading) {
        if (customLoadingElement) {
            component = customLoadingElement
        } else {
            component = (
                <Stack justifyContent="center" alignItems="center" sx={{ height: '70vh' }}>
                    <CircularProgress color="primary" />
                </Stack>
            )
        }
    } else {
        component = children
    }

    return component;
}

export default Loading;